import React from 'react';
import './SharedCards.scss';

function SharedCards(props){
    return(
        <div className="shared-cards-part">
            <div className="main-part">
          <div className="content">
              <h1>{props.title}</h1>
             {props.desc ?  <p>{props.desc}</p> : null}
          </div>
      
          {props.list.map((d) => {
              return(
                  <Card {...d} />
              )
          })}
        
        </div>
        </div>
    )
};
export default SharedCards;

export function Card(props){
    return(
        <div className="main-card">
            <div className="circle" style={{ backgroundColor: `${props.bgColor}` }}>
                <div className="icon">
                  <img src=  {props.icon} />
                </div>
            </div>
            <h2>{props.title}</h2>
            {props.desc ? <p>{props.desc}</p> : null}
            <div className="line" style={{ backgroundColor: `${props.bgColor2}` }}></div>
        </div>
    )
};